import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import Empty from "../../utils/Empty";

import "./drop.css"


const InfoConsiliation = ({ showModal, handleClose }) => {
    const [modalShow, setModalShow] = React.useState(false);



    //Steps
    const [step, setStep] = useState(1); // Estado para el paso actual
    const totalSteps = 2; // Número total de pasos

    const nextStep = () => {
        if (step < totalSteps) setStep(step + 1);
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };


    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
        } else {
            setFileName('No hay ningún archivo seleccionado');
        }
    };
    useEffect(() => {
        if (!showModal) {
            setStep(1);
        }
    }, [showModal]);
    return (
        <>

            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Body>
                    <div className="position-relative">
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" onClick={() => handleClose(false)} title='Cerrar'>

                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <h4>Información de Conciliación</h4>

                    <div className={`paso ${step === 1 ? "activo" : ""}`}>
                        <div className=" p-2">
                            <h6>Carge los archivo de lotes correspondientes para realizar la conciliación bancaria </h6>
                            <div className="dropzone-container">
                                <label htmlFor="dropzone-file" className="dropzone-label">
                                    <div className="dropzone-content">
                                        <svg
                                            className="dropzone-icon"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16"
                                        >
                                            <path
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                            />
                                        </svg>
                                        <p className="dropzone-text">
                                            <span className="dropzone-bold">Haga clic para cargar archivo de lotes </span> 
                                        </p>
                                     
                                        <p className="file-name">{fileName}</p>
                                    </div>
                                    <input
                                        id="dropzone-file"
                                        type="file"
                                        className="dropzone-input"
                                        onChange={handleFileChange}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className={`paso ${step === 2 ? "activo" : ""}`}>
                        <div className="border-dashed rounded-3 bg-white p-2 mt-5 py-5">
                            <Empty title="Paso 2" msg="Ingrese el lote correspondiente a la transacción" />
                        </div>
                    </div>

                    <div className={`paso ${step === 3 ? "activo" : ""}`}>
                        <div className="border-dashed rounded-3 bg-white p-2 mt-5 py-5">
                            <Empty title="Paso 3" msg="No se ha realizado ninguna consulta" />
                        </div>
                    </div>
                    <div className="botones-navegacion">
                        <button onClick={prevStep} disabled={step === 1} type="button">
                            Anterior
                        </button>
                        <button onClick={nextStep} disabled={step === totalSteps} type="button" >
                            Siguiente
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default InfoConsiliation